import { Component, OnInit } from '@angular/core';

interface Converter {
  id: number;
  name: string;
  status: number; // 0 = inactive, 1 = active
  link: string;
  type: 'converter';
}

@Component({
  selector: 'app-converters',
  templateUrl: './converters.component.html',
  styleUrls: ['./converters.component.css']
})
export class ConvertersComponent implements OnInit {
  // Static list of converters
  items: Converter[] = [
    { id: 1, name: 'ERP Billians (predefined template for data import)', status: 1, link: 'https://qa7owig05f.execute-api.eu-central-1.amazonaws.com/', type: 'converter' },
    { id: 2, name: 'ERP e-Line (KUF-posting order)', status: 1, link: 'https://jreipy1u4d.execute-api.eu-central-1.amazonaws.com/', type: 'converter' },
    { id: 3, name: 'ERP e-Line (KIF-posting order)', status: 1, link: 'https://tszht4c4b0.execute-api.eu-central-1.amazonaws.com/', type: 'converter' },
    { id: 4, name: 'ERP e-Line (ČLANARINE-posting order)', status: 1, link: 'https://r95gmnxu72.execute-api.eu-central-1.amazonaws.com/', type: 'converter' },
    { id: 5, name: 'ERP e-Line – Bank Statement Conversion (TXT from NLB, Nova Banka, ASA BAM, ASA EUR, UCB USD, UCB EUR into a predefined e-Line XML)', status: 1, link: 'https://uz2ke2cepk.execute-api.eu-central-1.amazonaws.com/', type: 'converter' },
    { id: 6, name: 'E-KUF BIH (elektronski kuf UIO)', status: 1, link: 'https://rt24sn311m.execute-api.eu-central-1.amazonaws.com/', type: 'converter' },
  ];

  isLoading = false;
  isSearching = false;
  hoveredIndex: number | null = null;
  openDropdownIndex: number | null = null;
  searchTemplateInput = '';
  showClearIcon = false;
  isInputFocused = false;
  activeSort = 'name';
  sort: any = {
    name: 'asc'
  };

  constructor() { }

  ngOnInit(): void { }

  // Handle mouse over for row highlighting
  onMouseOver(index: number): void {
    this.hoveredIndex = index;
  }

  onMouseLeave(index: number): void {
    this.hoveredIndex = null;
  }

  // Search/filter functionality
  filterConverters(searchTerm: string): void {
    this.isSearching = true;
    // Implement search logic here
    setTimeout(() => {
      this.isSearching = false;
    }, 300);
  }

  toggleIcon(): void {
    this.showClearIcon = this.searchTemplateInput.length > 0;
  }

  clearSearch(): void {
    this.searchTemplateInput = '';
    this.showClearIcon = false;
    this.filterConverters('');
  }

  // Sorting functionality
  toggleSort(field: string): void {
    this.activeSort = field;
    if (this.sort[field] === 'asc') {
      this.sort[field] = 'desc';
    } else {
      this.sort[field] = 'asc';
    }
  }

  // Open converter in new tab
  openConverter(converter: Converter, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    if (converter.status !== 1) {
      return;
    }

    const url = `/converter-page?converterUrl=${encodeURIComponent(converter.link)}`;
    window.open(url, '_blank');
  }
}